import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AdminDashboard from "@/pages/AdminDashboard";
import CustomerMenu from "@/pages/CustomerMenu";
import LoyaltyCard from "@/pages/LoyaltyCard";
import OrderTrack from "@/pages/OrderTrack";
import CustomerAccount from "@/pages/CustomerAccount";
import { LangProvider } from "@/lib/i18n";

function App() {
  useEffect(() => {
    document.title = "QRFoody — QR Food Ordering";
  }, []);
  return (
    <AuthProvider>
      <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/menu/:restaurantId" element={<CustomerMenu />} />
          <Route path="/loyalty/:restaurantId" element={<LoyaltyCard />} />
          <Route path="/track/:orderId" element={<OrderTrack />} />
          <Route path="/account/:restaurantId" element={<CustomerAccount />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors offset={12} mobileOffset={{ top: 64 }} />
      </LangProvider>
    </AuthProvider>
  );
}

export default App;
